import React from "react";
import { useAuth } from "@/context/AuthContext";
import SidebarLayout from "@/components/SidebarLayout";
import { UpgradeCTA } from "@/components/PaywallGate";
import { isAdminRole } from "@/data/v12_user_nav";

/**
 * Route-level module gate. If the current user's plan doesn't include
 * `module`, render the paywall inside the app shell instead of the page.
 * `role="admin"` variant restricts to admin users.
 *
 * F89 · uses `isAdminRole` SSOT so both `admin` and `super_admin` pass.
 */
export default function ModuleGate({ module, role, children }) {
    const { user, plan, loading, hasModule } = useAuth();
    if (loading) return null;
    if (role === "admin" && !isAdminRole(user?.role)) {
        return (
            <SidebarLayout>
                <div className="max-w-lg mx-auto py-20 px-6 text-center">
                    <h1 className="text-2xl font-semibold">Admin only</h1>
                    <p className="mt-2 text-sm text-text-secondary">
                        Non hai i permessi per accedere a questa area.
                    </p>
                </div>
            </SidebarLayout>
        );
    }
    if (module && !hasModule(module)) {
        return (
            <SidebarLayout>
                <div className="max-w-2xl mx-auto py-16 px-6">
                    <UpgradeCTA
                        required_module={module}
                        current_plan={plan?.id || user?.plan_id}
                    />
                </div>
            </SidebarLayout>
        );
    }
    return children;
}
